"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormDynamic = exports.useActions = exports.useInputValueFields = exports.useStatus = exports.isInvalidSchema = exports.useFormIsValid = exports.useFormValues = exports.useForm = exports.useInputValue = void 0;
const react_1 = require("react");
const useInputValue = (initialValue) => {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const [error, setError] = (0, react_1.useState)(null);
    const [touch, setTouch] = (0, react_1.useState)(false);
    const onChange = (e) => {
        setValue(e.target.value);
        !touch && setTouch(true);
    };
    const reset = () => setValue(initialValue);
    const dialog = setError;
    return {
        value,
        onChange,
        error,
        touch,
        reset,
        dialog,
        setTouch,
        setValue,
        helpText: error,
        isHelping: Boolean(error && touch),
    };
};
exports.useInputValue = useInputValue;
const useForm = (initialValues) => {
    const formData = {};
    for (const key in initialValues) {
        formData[key] = (0, exports.useInputValue)(initialValues[key]);
    }
    return { ...formData };
};
exports.useForm = useForm;
const useFormValues = (formData) => {
    let formValues = {};
    for (const value in formData) {
        formValues = {
            ...formValues,
            [value]: formData[value].value,
        };
    }
    return formValues;
};
exports.useFormValues = useFormValues;
const useFormIsValid = (data, schema) => {
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setIsValid(schema(data));
    }, [data, schema]);
    return isValid;
};
exports.useFormIsValid = useFormIsValid;
const isInvalidSchema = (schema) => Object.values(schema).some((item) => item === false);
exports.isInvalidSchema = isInvalidSchema;
const useStatus = () => {
    const [status, setStatus] = (0, react_1.useState)({
        isLoading: false,
        isSubmited: false,
        info: { isError: false, message: null },
    });
    const setIsLoading = (event) => setStatus((prevStatus) => ({ ...prevStatus, isLoading: event }));
    const setSubmited = (event) => setStatus((prevStatus) => ({ ...prevStatus, isSubmited: event }));
    const setIsError = (event) => setStatus((prevStatus) => ({
        ...prevStatus,
        info: {
            ...prevStatus.info,
            isError: event,
        },
    }));
    const setMessage = (message) => setStatus((prevStatus) => ({
        ...prevStatus,
        info: {
            ...prevStatus.info,
            message: message,
        },
    }));
    const resetStatus = () => {
        setStatus({
            isLoading: false,
            isSubmited: false,
            info: { isError: false, message: null },
        });
    };
    return {
        state: status,
        message: status.info.message,
        setStatus,
        setMessage,
        setIsLoading,
        setSubmited,
        setIsError,
        resetStatus,
    };
};
exports.useStatus = useStatus;
const useInputValueFields = () => {
    const [value, setValue] = (0, react_1.useState)({});
    const [error, setError] = (0, react_1.useState)({});
    const [touch, setTouch] = (0, react_1.useState)({});
    return {
        value,
        error,
        touch,
        setTouch,
        setValue,
        setError,
    };
};
exports.useInputValueFields = useInputValueFields;
const useActions = (formData) => {
    const resetForm = () => {
        for (const field in formData) {
            formData[field]?.reset();
        }
    };
    const touched = () => {
        for (const field in formData) {
            formData[field]?.setTouch(true);
        }
    };
    const getValues = () => {
        let formValues = {};
        for (const value in formData) {
            formValues = {
                ...formValues,
                [value]: formData[value].value,
            };
        }
        return formValues;
    };
    return { resetForm, touched, getValues };
};
exports.useActions = useActions;
const useFormDynamic = () => {
    const fields = (0, exports.useInputValueFields)();
    const onChange = (event) => {
        const { name, value } = event.target;
        fields.setValue((prev) => ({ ...prev, [name]: value }));
        fields.setTouch((prev) => ({ ...prev, [name]: true }));
    };
    const onChangeSelect = (event) => {
        const { name, value } = event.target;
        fields.setValue((prev) => ({ ...prev, [name]: value }));
        fields.setTouch((prev) => ({ ...prev, [name]: true }));
    };
    const dialog = (name, message) => {
        fields.setError((prev) => ({ ...prev, [name]: message }));
    };
    return { ...fields, onChange, onChangeSelect, dialog };
};
exports.useFormDynamic = useFormDynamic;
